import { Button, Flex, Text } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';

export const ErrorFallback = () => {
  return (
    <Flex
      css={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <Text fontSize="22px" fontWeight={500} mb={4}>
        Oops! Something went wrong
      </Text>

      <Button onClick={() => window.location.reload()}>Reload Page</Button>
    </Flex>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const { ErrorBoundary, withErrorBoundary } = Sentry;
